import { sanitizeModel } from '@/common/utils/modelDecorator'

export default {
  computed: {
    storesModel() {
      return sanitizeModel({
        title: 'Stores',
        endpoint: this.$appConfig.api.baseUrl + 'companies/' + this.profile.company_id + '/stores',
        // Create, edit and delete use the custom StoreForm modal of the stores page
        allowNew: false,
        editInPlace: false,
        allowDelete: false,
        fields: [
          {
            key: 'id',
            sortable: true,
            label: this.$gettext('ID')
          },
          {
            key: 'reference',
            sortable: true,
            label: this.$gettext('Reference')
          },
          {
            key: 'place_id',
            label: this.$gettext('Address'),
            formatter: (value, key, item) => {
              return item.place?.formatted_address || '-'
            }
          },
          {
            key: 'address_extra',
            sortable: true,
            label: this.$gettext('Floor, door, etc.')
          },
          {
            key: 'contact',
            sortable: true,
            label: this.$gettext('Contact Name')
          },
          {
            key: 'email',
            sortable: true,
            label: this.$gettext('Contact Email')
          },
          {
            key: 'phone',
            sortable: true,
            label: this.$gettext('Contact Phone')
          }
        ],
        extraActions: [
          {
            type: 'b-dropdown-item-button',
            position: 'start',
            variant: 'primary',
            icon: 'edit',
            label: this.$gettext('Edit'),
            action: (item) => {
              this.$root.$emit('Stores::edit', item)
            }
          },
          {
            type: 'b-dropdown-item-button',
            position: 'start',
            variant: 'danger',
            icon: 'trash-alt',
            label: this.$gettext('Delete'),
            action: (item) => {
              this.$root.$emit('Stores::delete', item)
            }
          }
        ],
        filters: [
          'id',
          'reference'
        ],
        includes: [
          'place'
        ]
      })
    }
  }
}
